module.exports = __webpack_public_path__ + "img/member.539269b0.svg";